export default null;throw new Error("Unable to resolve \"./constants\" from npm:pngjs@5.0.0/browser.js");